module.exports = __webpack_public_path__ + "img/2.f1b01300.png";